import { Fragment, useContext } from 'react'
import { Link, Outlet } from 'react-router-dom'
import { useLocation } from 'react-router'
import { AppContext } from '../App'
import { SidePanel } from './SidePanel'
import { Footer } from '../components/Footer.jsx'

export const SplitScreenTemplate = () => {
  const { isDesktopView } = useContext(AppContext)

  const location = useLocation()
  const locationArr = location.pathname.split('/')
  let isViewingIndexRoute = true

  for (let i = 0; i < locationArr.length; i++)
    if (!locationArr[i] || locationArr[i] === 'index') {
      continue
    } else {
      isViewingIndexRoute = false
      break
    }

  const breadcrumbs = [{ label: 'menu', path: '/index' }]

  locationArr.forEach((item, index) => {
    if (index > 1) {
      breadcrumbs.push({
        label: item.replaceAll('_', ' '),
        path: `${breadcrumbs[0].path}/${item}`
      })
    }
  })

  return (
    <div className='split_screen'>
      <SidePanel isViewingIndexRoute={isViewingIndexRoute} />
      <div>
        {(isDesktopView || !isViewingIndexRoute) && (
          <nav className='icon_grid'>
            <span className='material-symbols-rounded'>menu</span>
            <div>
              {breadcrumbs.map((item, index) => {
                if (index === breadcrumbs.length - 1)
                  return <span key={item.path}>{item.label}</span>
                else
                  return (
                    <Fragment key={item.path}>
                      <Link to={item.path}>{item.label}</Link>
                      <span>○</span>
                    </Fragment>
                  )
              })}
            </div>
          </nav>
        )}
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  )
}
